module.exports = __webpack_public_path__ + "img/8.22ad30a1.webp";